import { ExternalLink } from 'lucide-react';

import { Button } from '@/components/ui/catalyst/button';
import { Tooltip } from '@/components/ui/v3/Tooltip';

interface OpenInDirectoryButtonProps {
  /** The provider_service_ref_id linking to the v2 directory */
  providerServiceRefId?: string | null;
  /** Optional variant for button styling */
  variant?: 'icon' | 'text';
}

/**
 * Button that opens the linked ProviderService in the Provider Directory.
 * Only renders when providerServiceRefId is set.
 */
export const OpenInDirectoryButton = ({
  providerServiceRefId,
  variant = 'icon',
}: OpenInDirectoryButtonProps) => {
  if (!providerServiceRefId) {
    return null;
  }

  const handleOpenDirectory = () => {
    const url = `/provider-directory?view=services&service=${providerServiceRefId}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'text') {
    return (
      <Button outline onClick={handleOpenDirectory} className="gap-2">
        <ExternalLink className="h-4 w-4" />
        Open in Directory
      </Button>
    );
  }

  return (
    <Tooltip content="Open in Provider Directory" variant="dark" side="top">
      <Button plain onClick={handleOpenDirectory}>
        <ExternalLink className="w-6 h-6" />
      </Button>
    </Tooltip>
  );
};
